import type { GameContext } from './types';

/**
 * Global game context. Set once by main.ts before any system update runs.
 * Modules read `G.player`, `G.city`, ... at runtime (never at import time).
 */
export let G: GameContext = null as unknown as GameContext;

export function setContext(ctx: GameContext): void {
  G = ctx;
}
